// extracted by mini-css-extract-plugin
module.exports = {"main_nav":"main_nav-1lGoAj42","user":"user-1SyzRh3v","box":"box-1NE7OVBU","ad":"ad-3dCK3Nz-","search":"search-3X_e_JDy","logo":"logo-3DkfwxY_"};